import classNames from 'classnames';
import moment from 'moment';
import React, { FC, ReactNode } from 'react';
import { User } from 'api/models';
import { Avatar } from 'components/atoms/avatar';
import { RelativeTime } from 'components/atoms/relative-time';
import { fullName } from 'utils/full-name';
import styles from './user-info-action.module.css';

interface Props {
  userClass: string;
  className?: string;
  user: User;
  createdAt: number;
  action?: () => ReactNode;
}

export const UserInfoAction: FC<Props> = ({
  user,
  userClass = '',
  createdAt,
  className = '',
  action,
}: Props) => (
  <div className={classNames(styles.wrapper, { [className]: true })}>
    <div className={styles.content__left}>
      <Avatar
        size="small"
        className={styles.avatar}
        src={user?.photoUrl}
        name={user?.firstName}
      />
      <span className={`${styles.user} ${userClass}`}>
        {fullName(user)}
        <span className="separator" />
      </span>
      <span className={`${styles.time}`}>
        <RelativeTime time={moment(createdAt)} />
      </span>
    </div>
    <div className={styles.content__right}>
      <div className={styles.actions}>{action ? action() : null}</div>
    </div>
  </div>
);
